(() => {
class GiveawayProgressDrawer {
  constructor(element) {
    this.element = element;
    this.message = element.querySelector('[data-cart-giveaway-message]');
    this.tiers = Array.from(element.querySelectorAll('.cart-drawer-giveaway-progress__tier'))
      .map((tier) => ({
        element: tier,
        threshold: Number.parseFloat(tier.dataset.threshold),
        entries: Number.parseInt(tier.dataset.entryCount, 10) || 0,
      }))
      .sort((a, b) => a.threshold - b.threshold);
    this.refreshTimeout = null;
    this.handleCartEvent = () => this.scheduleRefresh(200);

    document.addEventListener('ajaxProduct:added', this.handleCartEvent);
    document.addEventListener('cart:updated', this.handleCartEvent);
    document.addEventListener('cart:rebuilt', this.handleCartEvent);
    document.addEventListener('cart:change', this.handleCartEvent);
    this.refresh();
  }

  scheduleRefresh(delay = 0) {
    window.clearTimeout(this.refreshTimeout);
    this.refreshTimeout = window.setTimeout(() => this.refresh(), delay);
  }

  async refresh() {
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return;
      const cart = await response.json();
      this.updateDisplay((cart.items_subtotal_price || cart.total_price || 0) / 100);
    } catch (error) {
      console.warn('Giveaway cart progress could not refresh cart data.', error);
    }
  }

  updateDisplay(cartTotal) {
    const unlockedTier = [...this.tiers].reverse().find((tier) => cartTotal >= tier.threshold);
    const nextTier = this.tiers.find((tier) => cartTotal < tier.threshold);

    if (nextTier) {
      const amountAway = this.formatMoney(nextTier.threshold - cartTotal);
      this.message.innerHTML = `You're <strong>${amountAway}</strong> away from <strong>+${this.formatInteger(nextTier.entries)} Entries</strong>.`;
    } else {
      this.message.innerHTML = `You've unlocked <strong>+${this.formatInteger(unlockedTier.entries)} Entries</strong>!`;
    }

    this.tiers.forEach((tier, index) => {
      const previousThreshold = index ? this.tiers[index - 1].threshold : 0;
      const span = tier.threshold - previousThreshold;
      const percentage = cartTotal >= tier.threshold
        ? 100
        : cartTotal > previousThreshold && span > 0
          ? ((cartTotal - previousThreshold) / span) * 100
          : 0;
      tier.element.classList.toggle('is-completed', cartTotal >= tier.threshold);
      const fill = tier.element.querySelector('.cart-drawer-giveaway-progress__fill');
      if (fill) {
        fill.style.width = `${Math.min(Math.max(percentage, 0), 100)}%`;
      }
    });
  }

  formatInteger(value) {
    return new Intl.NumberFormat(document.documentElement.lang || navigator.language).format(value);
  }

  formatMoney(amount) {
    return new Intl.NumberFormat(document.documentElement.lang || navigator.language, {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: 'narrowSymbol',
    }).format(amount);
  }
}

const initialize = (scope = document) => {
  scope.querySelectorAll('[data-cart-giveaway-progress]').forEach((element) => {
    if (!element.__giveawayProgressDrawer) {
      element.__giveawayProgressDrawer = new GiveawayProgressDrawer(element);
    }
  });
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
} else {
  initialize();
}
document.addEventListener('shopify:section:load', (event) => initialize(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-cart-giveaway-progress]').forEach((element) => {
    const instance = element.__giveawayProgressDrawer;
    if (!instance) return;
    window.clearTimeout(instance.refreshTimeout);
    ['ajaxProduct:added', 'cart:updated', 'cart:rebuilt', 'cart:change'].forEach((name) => {
      document.removeEventListener(name, instance.handleCartEvent);
    });
    delete element.__giveawayProgressDrawer;
  });
});
})();
